import { AppSidebar } from "@/components/app-sidebar"
import { Separator } from "@/components/ui/separator"
import { SidebarInset, SidebarTrigger } from "@/components/ui/sidebar"

export function Page({
  headerSlot,
  children,
}: {
  headerSlot?: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <>
      <AppSidebar />
      <SidebarInset>
        <div className="flex flex-1 flex-col">
          <div className="@container/main flex flex-1 flex-col">
            <div className="flex items-center h-16 gap-2 border-b w-full px-5 justify-between">
              <div className="flex items-center gap-2 ">
                <header className="flex h-16 shrink-0 items-center gap-2">
                  <div className="flex items-center gap-2 px-4">
                    <SidebarTrigger className="-ml-1" />
                    <Separator
                      orientation="vertical"
                      className="mr-2 data-[orientation=vertical]:h-4"
                    />
                  </div>
                  {headerSlot}
                </header>
              </div>
            </div>
            <div className="p-6">{children}</div>
          </div>
        </div>
      </SidebarInset>
    </>
  )
}
